import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Flame } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/** Trending hashtags strip over the Reels player (last 7 days of video posts). */
export default function TrendingHashtagsStrip() {
  const navigate = useNavigate();
  const [tags, setTags] = useState([]);
  useEffect(() => {
    axios.get(`${API}/hashtags/trending?limit=12`).then((r) => setTags(r.data?.tags || [])).catch(() => {});
  }, []);
  if (tags.length === 0) return null;
  return (
    <div className="fixed top-14 inset-x-0 z-[154] px-3 pointer-events-none" data-testid="reels-trending-strip">
      <div className="max-w-xl mx-auto flex items-center gap-2 overflow-x-auto scrollbar-hide pointer-events-auto">
        <span className="shrink-0 inline-flex items-center gap-1 text-[10px] font-bold uppercase tracking-widest text-orange-300 drop-shadow"><Flame className="w-3.5 h-3.5" /> Em alta</span>
        {tags.map((t) => (
          <button
            key={t.tag}
            type="button"
            onClick={() => navigate(`/tag/${encodeURIComponent(t.tag)}`)}
            data-testid={`reels-trending-${t.tag}`}
            className="shrink-0 h-7 px-3 rounded-full bg-white/15 hover:bg-white/30 backdrop-blur-md text-white text-xs font-semibold transition-colors whitespace-nowrap"
            title={`${t.posts} vídeo${t.posts === 1 ? "" : "s"}`}
          >
            #{t.tag} <span className="opacity-60 font-normal">· {t.posts}</span>
          </button>
        ))}
      </div>
    </div>
  );
}
